import type { FolderFormValues, FolderFooterHintProps } from './types';
import { getFooterHintKey } from './folderFormState';

export type { FolderFooterHintProps };

export function FolderFooterHint({
  values,
  serverError,
  t,
  requireCompleteTravellers = false,
}: FolderFooterHintProps) {
  if (serverError) {
    return (
      <span className="text-sm font-medium text-red-600">{serverError}</span>
    );
  }

  const { key, params } = getFooterHintKey(values, {
    requireCompleteTravellers,
  });
  // Only the "travellers required" hint stands for something the user *must*
  // fix before saving: the others are plain guidance.
  const isBlocking = key === 'footerHintTravellersRequired';

  return (
    <span
      className={`text-sm ${
        isBlocking ? 'font-medium text-amber-600' : 'text-gray-500'
      }`}
    >
      {t(key, params)}
    </span>
  );
}
